export default __webpack_public_path__ + "static/media/deal-16.1eafcf79.webp";